module.exports = __webpack_public_path__ + "img/sceau_ward.bf469d6b.jpg";